export default __webpack_public_path__ + "static/media/Blade's Grips of the Grim Cabal.05ae6be9.jpg";